import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import { TeamOccupancyFilterInput } from './inputs';
import { TeamOccupancyResource } from './resources';
import { TeamRefList } from './refs';

export default class TeamOccupancy {
    private basePath = '/api/team-occupancy';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get list of team occupancy objects
    get = async (filter: TeamOccupancyFilterInput): Promise<CollectionResource<TeamOccupancyResource, {}>> => {
        const query = qs.stringify({ ...filter });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Process occupancy calculation for specific team ID
    processCalculation = async (userId: ID): Promise<TeamRefList> => {
        const { data } = await this.http.post(`${this.basePath}/compute/id/${userId}`);

        return data;
    };
}
